import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import styles from './viewPart.module.css';
import { useBreadcrumbs } from '../../../../components/ui/breadcrumps/breadcrumbsContext';
import { useCRUD } from '../../../../api/crud';
import { PARTS_ENDPOINT } from '../../../../consts';

export const ViewPart = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { setOverride } = useBreadcrumbs();
  const { get } = useCRUD(PARTS_ENDPOINT);

  const pathname = location.pathname;
  const partId = id;
  const basePath = partId ? `/service/stock-status/${partId}` : '/service/stock-status';

  // Fetch client data for breadcrumb override
  useEffect(() => {
    const fetchPart = async () => {
      if (id) {
        const response = await get(id);
        setOverride(`/service/stock-status/${id}`, response.data ? response.data.name : id);
      }
    };
    fetchPart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const visibleTabs = [
    { key: 'basic', path: basePath },
    { key: 'ordered-parts', path: `${basePath}/ordered-parts` },
    { key: 'used-parts', path: `${basePath}/used-parts` },
  ];

  const getTabValue = () => {
    if (pathname.includes('/used-parts')) {
      const index = visibleTabs.findIndex(tab => tab.key === 'used-parts');
      return index >= 0 ? index : 0;
    }
    if (pathname.includes('/ordered-parts')) {
      const index = visibleTabs.findIndex(tab => tab.key === 'ordered-parts');
      return index >= 0 ? index : 0;
    }
    return 0;
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    const selectedTab = visibleTabs[newValue];
    if (selectedTab) {
      navigate(selectedTab.path);
    } else {
      navigate(basePath);
    }
  };

  return (
    <Box className={styles.container}>
      <Tabs
        value={getTabValue()}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        {visibleTabs.map((tab) => {
          const labels: Record<string, string> = {
            basic: t("Basic Information"),
            "ordered-parts": t("Ordered Parts"),
            "used-parts": t("Used Parts"),
          };
          return <Tab key={tab.key} label={labels[tab.key]} />;
        })}
      </Tabs>
      <Box className={styles.content}>
        <Outlet />
      </Box>
    </Box>
  );
};
